import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$localiseOrderTimes',
  initialState,
  reducers: {
    setLocaliseOrderTimes(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setLocaliseOrderTimes } = slice.actions;
export default slice.reducer;
